/**
 * Internal dependencies
 */
import { bold } from './bold';
import { code } from './code';
import { image } from './image';
import { italic } from './italic';
import { link } from './link';
import { strikethrough } from './strikethrough';
import { underline } from './underline';
import { textColor } from './text-color';
import { subscript } from './subscript';
import { superscript } from './superscript';
import { keyboard } from './keyboard';
import { unknown } from './unknown';
import { language } from './language';
import { math } from './math';
import { nonBreakingSpace } from './non-breaking-space';

export default [
	bold,
	code,
	image,
	italic,
	link,
	strikethrough,
	underline,
	textColor,
	subscript,
	superscript,
	keyboard,
	unknown,
	language,
	math,
	nonBreakingSpace,
];
